export const turnOffFullScreenMode = (ref) => {
  switch (true) {
    case !!ref.exitFullscreen:
      ref.exitFullscreen().catch((err) => console.log(err));
      break;
    case !!ref.mozCancelFullScreen /* Firefox */:
      ref.mozCancelFullScreen();
      break;
    case !!ref.webkitExitFullscreen /* Chrome, Safari and Opera */:
      ref.webkitExitFullscreen();
      break;
    case !!ref.msExitFullscreen /* IE/Edge */:
      ref.msExitFullscreen();
      break;
    default:
      break;
  }
};
